<article>
	<header>
		<h3>
			{{ 'adminstat.users.role.List of providers and filters' | translate }}
		</h3>
	</header>
	
	<section>
		<a role="button" class="btn btn-link" (click)="addProvider()">
			<i class="fa fa-fw fa-plus"></i>
		</a>
	</section>
	
	<section>
		<loading [isLoad]="isProviderLoad"></loading>
		
		<table class="table">
			<thead>
				<tr>
					<th></th>
					<th>name</th>
					<th>filter</th>
				</tr>
			</thead>
			
			<tbody>
				<tr *ngFor="let provider of providers">
					<td>
						<div class="btn-group" role="group" aria-label="Basic example">
							<a role="button" class="btn btn-link" (click)="editProvider(provider)">
								<i class="fa fa-fw fa-edit"></i>
							</a>
							<a role="button" class="btn btn-link" (click)="deleteProvider(provider)">
								<i class="fa fa-fw fa-trash"></i>
							</a>
						</div>
					</td>
					
					<td>
						{{ provider.name }}
					</td>
					
					<td>
						<code>
							{{ provider.filter | json }}
						</code>
					</td>
				</tr>
			</tbody>
		</table>
	</section>
</article>


<article>
	<header>
		<h3>List of users and roles</h3>
	</header>
	
	<section>
		<a role="button" class="btn btn-link" (click)="addRole()">
			<i class="fa fa-fw fa-plus"></i>
		</a>
	</section>
	
	<section>
		<loading [isLoad]="isRoleLoad"></loading>
		
		<table class="table">
			<thead>
			<tr>
				<th></th>
				<th>Created</th>
				<th>Username</th>
				<th>Email</th>
				<th>Contractor|Role</th>
			</tr>
			</thead>
			
			<tbody>
			<tr *ngFor="let role of roles">
				<td>
					<div class="btn-group" role="group" aria-label="Basic example">
						<a role="button" class="btn btn-link" (click)="editRole(role)">
							<i class="fa fa-fw fa-edit"></i>
						</a>
						
						<a role="button" class="btn btn-link" (click)="deleteRole(role)">
							<i class="fa fa-fw fa-trash"></i>
						</a>
					</div>
				</td>
				
				<td>
					{{ role.created | dateTimeFormat }}
				</td>
				
				<td>
					{{ role.username }}
				</td>
				
				<td>
					{{ role.email }}
				</td>
				
				<td>
					<ul>
						<li *ngFor="let allow of role.allows">
							<ng-template [ngIf]="allow.providerName">
								{{ allow.providerName }}.
							</ng-template>
							
							{{ allow.role }}
						</li>
					</ul>
				</td>
			</tr>
			</tbody>
		</table>
	</section>
</article>
